import api from './api';

class BCVService {
  async getRates() {
    try {
      const response = await api.get('/api/bcv/rates');
      return response.data;
    } catch (error) {
      console.error('Error obteniendo tasas BCV:', error);
      return { success: false, data: { USD: 0, EUR: 0 } };
    }
  }

  async convertCurrency(fromCurrency, toCurrency, amount) {
    try {
      const response = await api.post('/api/bcv/convert', {
        from_currency: fromCurrency,
        to_currency: toCurrency,
        amount: amount
      });
      return response.data;
    } catch (error) {
      console.error('Error en conversión BCV:', error);
      return { success: false, error: 'Error en conversión' };
    }
  }

  // Conversiones específicas para el tab de finanzas
  async convertBsToUsd(amountBs) {
    return this.convertCurrency('VES', 'USD', amountBs);
  }

  async convertUsdToEur(amountUsd) {
    return this.convertCurrency('USD', 'EUR', amountUsd);
  }

  async getHistoricalRate(currency, date) {
    try {
      const response = await api.get(`/api/bcv/rates/historical/${currency}/${date}`);
      return response.data;
    } catch (error) {
      console.error(`Error obteniendo tasa histórica ${currency} para ${date}:`, error);
      return { success: false, error: 'Error obteniendo tasa histórica' };
    }
  }

  // Formatear números con coma venezolana
  formatVenezuelanCurrency(amount) {
    if (!amount && amount !== 0) return '';
    return amount.toString().replace('.', ',');
  }

  // Parsear números con coma venezolana
  parseVenezuelanCurrency(value) {
    if (!value) return 0;
    return parseFloat(value.replace(',', '.'));
  }
}

export default new BCVService();
